module.exports = __webpack_public_path__ + "static/img/ar.d205ca13.svg";